import { useFormik } from "formik"
import * as Yup from "yup"
import React from "react"
import {
  Card,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
} from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import SingleSelect from "components/Common/SelectBoxes/SingleSelect"

const ShipmentForm = ({ onSubmit, loading, error, formMode, shipment }) => {
  const validationType = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: shipment ? shipment?.name : "",
      status: shipment ? shipment?.status : "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("This name is required").min(3),
      status: Yup.string().required("This status is required"),
    }),
    onSubmit: values => {
      onSubmit(values)
    },
  })

  return (
    <Card>
      <CardBody>
        <CustomHeaderTitle
          loading={loading}
          title={formMode === "Edit" ? "Edit Shipment" : "Add Shipment"}
          lgColumn={3}
          rowCount={false}
          orderingList={false}
          searchBox={false}
          rightBtn={true}
          rightBtnTitle={"Back"}
          rightBtnRoute={"/shipments"}
        />

        <Form
          onSubmit={e => {
            e.preventDefault()
            validationType.handleSubmit()
            return false
          }}
        >
          <div className="mb-3">
            <Label className="form-label">Name</Label>
            <Input
              name="name"
              placeholder="Name"
              type="text"
              onChange={validationType.handleChange}
              onBlur={validationType.handleBlur}
              value={validationType.values.name || ""}
              invalid={
                (validationType.touched.name && validationType.errors.name) ||
                error?.name?.[0]
                  ? true
                  : false
              }
            />
            {(validationType.touched.name && validationType.errors.name) ||
            error?.name?.[0] ? (
              <FormFeedback type="invalid">
                {validationType.errors.name || error?.name?.[0]}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label className="form-label">Status</Label>
            <SingleSelect
              defaultValue={shipment?.status}
              name="status"
              options={[
                { value: "Active", label: "Active" },
                { value: "Deactive", label: "Deactive" },
              ]}
              formik={validationType}
              formMode={formMode}
            />
            {(validationType.touched.status && validationType.errors.status) ||
            error?.status?.[0] ? (
              <FormFeedback type="invalid">
                {validationType.errors.status || error?.status?.[0]}
              </FormFeedback>
            ) : null}
          </div>

          <div className="d-flex flex-wrap gap-2">
            <Button type="submit" color="primary" disabled={loading}>
              {loading
                ? "Please Wait..."
                : formMode === "Add"
                ? "Submit"
                : "Update"}
            </Button>
          </div>
        </Form>
      </CardBody>
    </Card>
  )
}

export default ShipmentForm
